import { Lang } from 'Roblox';
import angular from 'angular';

let dependencies = ["robloxApp", "monospaced.elastic", "modal", "ui.bootstrap.popover", "toast"];
const voiceModule = "voiceChat";
try {
    angular.module(voiceModule);
    dependencies.push(voiceModule);
} catch (err) {}

let chat = angular
    .module("chat", dependencies)
    .config(['msdElasticConfig', 'languageResourceProvider', function (msdElasticConfig, languageResourceProvider) {
        msdElasticConfig.append = "\n";
        if (Lang.ChatResources) {
            languageResourceProvider.setLanguageKeysFromFile(Lang.ChatResources);
        }
    }]);

export default chat;



